function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M29.1211,16.8789A2.98,2.98,0,0,0,27.01,16H27a2.9774,2.9774,0,0,0-2.1211.8789L19.9778,21.78A2.9943,2.9943,0,0,0,17,19H10a5.0059,5.0059,0,0,0-5,5v.667L2,28.6631l1.6,1.2L7,25.333V24a3.0033,3.0033,0,0,1,3-3h7a1,1,0,0,1,0,2H13v2h4.9287a3.9717,3.9717,0,0,0,2.8286-1.1719L26.293,18.293A.9929.9929,0,0,1,27,18h.0034a1,1,0,0,1,.7036,1.707l-7.414,7.4141A2.9791,2.9791,0,0,1,18.1714,28H11v2h7.1714a4.9665,4.9665,0,0,0,3.5356-1.4648l7.4141-7.4141a2.9989,2.9989,0,0,0,0-4.2422Z"
});

var _ref4 = /*#__PURE__*/React.createElement("polygon", {
  points: "21.586 8.586 18 12 18 2 16 2 16 12 12.414 8.586 11 10 17 16 23 10 21.586 8.586"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  "data-name": "<Transparent Rectangle>",
  height: 32,
  id: "_Transparent_Rectangle_",
  width: 32
});

function SvgNeedIcon216658(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 32,
    id: "icon",
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeedIcon216658);
export default __webpack_public_path__ + "static/media/need_icon_216658.8a73f878.svg";
export { ForwardRef as ReactComponent };